import { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";

export const MaskedLines = ({ lines, className = "", delay = 0, as: Tag = "span" }) => {
  return (
    <Tag className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Reveal = ({ children, className = "", delay = 0, y = 28, once = true }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount: 0.15 });
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`font-mono text-[11px] uppercase tracking-[0.28em] font-bold flex items-center gap-3 ${light ? "text-safety" : "text-safety"}`}>
    <span className="inline-block w-8 h-[2px] bg-safety" aria-hidden="true" />
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, title, sub, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <Eyebrow>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight text-bone mt-5">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="text-steel text-base sm:text-lg leading-relaxed mt-6">{sub}</p>
      </Reveal>
    )}
  </div>
);
